export default __webpack_public_path__ + "static/media/nepal-government.5ff0c104.png";